const FILE_UPLOAD_URL = '/umbraco/surface/fileupload/upload'

/**
 * Reads the file chosen in a D365 Marketing embedded form's file field. The form renders
 * input[type="file"] (name="UploadFile") but does not push the file to CRM — callers upload
 * via uploadD365FormFile after submit.
 */
export function captureD365FormFile(formRoot) {
  if (!formRoot?.querySelector) return null
  const input = formRoot.querySelector('input[type="file"]')
  return input?.files?.[0] ?? null
}

/**
 * Forwards a captured D365 form file to the member file-upload surface endpoint. Best-effort:
 * failures are logged but do not reject the returned promise.
 */
export function uploadD365FormFile(file, logContext = 'D365Form') {
  return new Promise((resolve) => {
    if (!file) {
      resolve()
      return
    }

    const reader = new FileReader()
    reader.onload = async () => {
      try {
        const base64Content = String(reader.result || '').split(',')[1] || ''
        const res = await fetch(FILE_UPLOAD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            base64Content,
            fileName: file.name,
            mimeType: file.type || 'application/octet-stream',
          }),
        })
        if (!res.ok) {
          console.error(`[${logContext}] file upload failed:`, res.status)
        }
      } catch (err) {
        console.error(`[${logContext}] file upload error:`, err)
      }
      resolve()
    }
    reader.onerror = () => resolve()
    reader.readAsDataURL(file)
  })
}
